<template>
  <div class="intro-container">
    <h1 class="intro-title">내가 보는 주역점이란?</h1>
    <p class="intro-description">
      주역점을 치는 과정은 복잡하고 시간이 많이 소요됩니다. 인생의 역점은 당신의
      마음을 담은
      <strong>여섯번의 선택</strong>
      을 주역점 절차로 치환하여 효(爻)와 괘(卦)를 뽑아 주역의 지혜에 따른 명쾌한
      해석을 제공합니다. 질문을 깊이 생각하고 마음을 다해 과정을 진행하여 답을
      구하는 것이 정확한 응답에 한층 더 가까워지는 길입니다.
      <br />
      가끔은 여러분이 주역 점술가가 되어 다른 사람을 위해 점을 쳐주는 재미도
      느껴보세요.({{ LYD }}LYD 필요)
    </p>

    <div class="intro-actions">
      <label class="checkbox">
        <input type="checkbox" v-model="skipNext" />
        다시 보지 않기
      </label>
      <div class="buttons">
        <button @click="proceed">이용하기</button>
        <button @click="cancel">돌아가기</button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'

  const LYD = ref(import.meta.env.VITE_CHARGE_ICHING)
  const router = useRouter()
  const skipNext = ref(false)
  const storageKey = 'skipIntroDivination'
  const proceedTo = '/Divination'

  function proceed() {
    if (skipNext.value) {
      localStorage.setItem(storageKey, 'true')
    }
    router.replace(proceedTo)
  }

  function cancel() {
    router.go(-1)
  }

  onMounted(() => {
    if (localStorage.getItem(storageKey) === 'true') {
      router.replace(proceedTo)
    }
  })
</script>

<style scoped>
  .intro-container {
    min-height: 100vh;
    width: var(--device-width);
    max-width: 480px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1.2rem;
    box-sizing: border-box;
    text-align: center;
  }

  .intro-title {
    font-size: var(--font-size-16);
    font-weight: bold;
    margin-bottom: 1.5rem;
  }

  .intro-description {
    font-size: var(--font-size-11);
    line-height: 1.6;
    margin-bottom: 2rem;
    width: 90%;
  }

  .intro-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .checkbox {
    font-size: var(--font-size-09);
  }

  .buttons {
    display: flex;
    gap: 1.2rem;
  }

  button {
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 8px;
    background-color: #333;
    color: white;
    cursor: pointer;
  }

  button:first-child {
    background-color: #4caf50; /* Green */
    color: white;
  }

  button:first-child:hover {
    background-color: #45a049;
  }

  button:last-child {
    background-color: #f44336; /* Red */
    color: white;
  }

  button:last-child:hover {
    background-color: #da190b;
  }
</style>
